import baseUrl from "../config/baseUrl";

const dashboardData = async ({ token, userID, isAdmin }) => {
  try {
    const response = await fetch(
      `${baseUrl}/apireact/dashboard_get_data_pie_chart?isNonAdmin=0&isAdmin=${isAdmin}`,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default dashboardData;
